import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22settings.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./font/basier-mono/semibold/basiersquaremono-semibold-webfont.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22}],%22variable%22:%22--font-basier-square-mono%22}],%22variableName%22:%22BasierSquareMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'BasierSquareMono', 'BasierSquareMono Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
